// Multi-step form navigation
let currentPage = 1;
const totalPages = 3;
let lastFetchedZip = '';
let storeData = [];
let userHasTaxCert = false;
let storeSkuCount = 0;
let carblissSoldAtLocation = true;

// Eligible states where Carbliss is distributed (full names and abbreviations)
const eligibleStates = [
  'arizona',
  'az',
  'arkansas',
  'ar',
  'colorado',
  'co',
  'florida',
  'fl',
  'illinois',
  'il',
  'georgia',
  'ga',
  'iowa',
  'ia',
  'indiana',
  'in',
  'kansas',
  'ks',
  'kentucky',
  'ky',
  'louisiana',
  'la',
  'michigan',
  'mi',
  'minnesota',
  'mn',
  'missouri',
  'mo',
  'nebraska',
  'ne',
  'new jersey',
  'nj',
  'new york',
  'ny',
  'north dakota',
  'nd',
  'ohio',
  'oh',
  'south dakota',
  'sd',
  'texas',
  'tx',
  'tennessee',
  'tn',
  'wisconsin',
  'wi',
];

// Helper function to check if state is eligible for donations
function isEligibleState(state) {
  if (!state) return false;
  return eligibleStates.includes(state.toLowerCase().trim());
}

// Check if address fields should be shown
function checkAddressVisibility() {
  // Always show address fields
  $('.fc-address-fields').show();
  $('#address_line_1, #city, #state, #zip').attr('required', true);
}

// Toggle shipping address visibility based on checkbox
function toggleShippingAddress() {
  const sameAddress = $('#same_shipping_address').is(':checked');

  if (sameAddress) {
    // Hide shipping fields and remove required
    $('.fc-shipping-address-fields').hide();
    $('#shipping_address_line_1, #shipping_city, #shipping_state, #shipping_zip').attr('required', false);
  } else {
    // Show shipping fields and add required
    $('.fc-shipping-address-fields').show();
    $('#shipping_address_line_1, #shipping_city, #shipping_state, #shipping_zip').attr('required', true);
  }
}

// Check if donation preference fields should be shown (only for large donations)
function checkDonationPreferenceVisibility() {
  const hasTaxCert = userHasTaxCert;
  const sellsCarbliss = carblissSoldAtLocation === true;
  const skuCount = storeSkuCount;

  // Show donation preference fields only for Large Donation
  const isLargeDonation = hasTaxCert && sellsCarbliss && skuCount >= 8;

  if (isLargeDonation) {
    $('.fc-donation-preference-field').show();
    $('input[name="donation_preference"]').attr('required', true);
  } else {
    $('.fc-donation-preference-field').hide();
    $('input[name="donation_preference"]').attr('required', false).prop('checked', false);
    // Also hide and clear the monetary donation fields
    $('.fc-monetary-donation-section').hide();
    $('.fc-monetary-upload-field').hide();
    $('#carbliss_cares_form').attr('required', false).val('');
  }
}

// Page navigation
function goToPage(pageNumber) {
  // Hide all pages
  $('.fc-form-page').removeClass('active');

  // Show target page
  $(`.fc-form-page[data-page="${pageNumber}"]`).addClass('active');

  // Update progress indicator
  $('.fc-progress-step').removeClass('active');
  $(`.fc-progress-step[data-step="${pageNumber}"]`).addClass('active');

  // Mark previous steps as completed
  for (let i = 1; i < pageNumber; i++) {
    $(`.fc-progress-step[data-step="${i}"]`).addClass('completed');
  }

  currentPage = pageNumber;

  // Show store lookup fields when entering page 2
  if (pageNumber === 2) {
    $('.fcsi-store-lookup').show();
  }

  // Check address and donation preference visibility when entering page 3
  if (pageNumber === 3) {
    checkAddressVisibility();
    checkDonationPreferenceVisibility();
  }
}

// Validate page 1
function validatePage1() {
  const firstName = $('#first_name').val().trim();
  const lastName = $('#last_name').val().trim();
  const email = $('#email').val().trim();
  const emailConfirm = $('#email_confirm').val().trim();
  const phone = $('#phone').val().trim();
  const taxCert = $('input[name="tax_cert"]:checked').val();
  const taxCertFile = $('#tax_cert_file')[0].files[0];

  // Clear previous errors
  $('.field-error').remove();
  $('.fcsi-field-group').removeClass('has-error');

  let isValid = true;

  if (!firstName) {
    showError('#first_name', 'First name is required');
    isValid = false;
  }

  if (!lastName) {
    showError('#last_name', 'Last name is required');
    isValid = false;
  }

  if (!email) {
    showError('#email', 'Email is required');
    isValid = false;
  } else if (!isValidEmail(email)) {
    showError('#email', 'Please enter a valid email address');
    isValid = false;
  }

  if (!emailConfirm) {
    showError('#email_confirm', 'Please verify your email address');
    isValid = false;
  } else if (emailConfirm !== email) {
    showError('#email_confirm', 'Email addresses do not match');
    isValid = false;
  }

  if (!phone) {
    showError('#phone', 'Phone number is required');
    isValid = false;
  }

  if (!taxCert) {
    showError('input[name="tax_cert"]', 'Please select an option', true);
    isValid = false;
  } else if (taxCert === 'no') {
    showError(
      'input[name="tax_cert"]',
      'Unfortunately, a tax exempt or non-profit certification is required to be eligible for a donation.',
      true,
    );
    isValid = false;
  }

  if (taxCert === 'yes' && !taxCertFile) {
    showError('#tax_cert_file', 'Please upload your tax certification');
    isValid = false;
  }

  return isValid;
}

// Validate page 2
function validatePage2() {
  const zipCode = $('#zip_code').val().trim();
  const storeName = $('#store_name').val().trim();

  // Clear previous errors
  $('.field-error').remove();
  $('.fcsi-field-group').removeClass('has-error');

  let isValid = true;

  const zipRegex = /^\d{5}(-\d{4})?$/;

  if (!zipCode) {
    showError('#zip_code', 'Zip code is required');
    isValid = false;
  } else if (!zipRegex.test(zipCode)) {
    showError('#zip_code', 'Please enter a valid zip code');
    isValid = false;
  }

  if (!storeName) {
    showError('#store_name', 'Store name is required');
    isValid = false;
  } else if ($('#store_name').attr('data-valid-store') !== 'true') {
    // The location must come from the VIP dropdown. If the typed name exactly
    // matches a VIP result, accept it (capturing its SKU count); otherwise the
    // location is not eligible and the applicant cannot proceed.
    const matchedStore = findStoreByName(storeName);
    if (matchedStore) {
      applyStoreSelection(matchedStore);
    } else {
      showError(
        '#store_name',
        'Please select your location from the dropdown list. If it is not listed, it is not eligible for a donation.',
      );
      isValid = false;
    }
  }

  return isValid;
}

// Validate page 3
function validatePage3() {
  const addressLine1 = $('#address_line_1').val().trim();
  const city = $('#city').val().trim();
  const state = $('#state').val().trim();
  const zip = $('#zip').val().trim();
  const eventFlyer = $('#event_flyer')[0].files[0];
  const isAddressVisible = $('.fc-address-fields').is(':visible');
  const isDonationPreferenceVisible = $('.fc-donation-preference-field').is(':visible');
  const donationPreference = $('input[name="donation_preference"]:checked').val();
  const carblissCaresForm = $('#carbliss_cares_form')[0].files[0];
  const isMonetaryUploadVisible = $('.fc-monetary-upload-field').is(':visible');
  const isShippingAddressVisible = $('.fc-shipping-address-fields').is(':visible');
  const shippingAddressLine1 = $('#shipping_address_line_1').val().trim();
  const shippingCity = $('#shipping_city').val().trim();
  const shippingState = $('#shipping_state').val().trim();
  const shippingZip = $('#shipping_zip').val().trim();

  // Clear previous errors
  $('.field-error').remove();
  $('.fcsi-field-group').removeClass('has-error');

  let isValid = true;

  // Validate address fields if visible
  if (isAddressVisible) {
    if (!addressLine1) {
      showError('#address_line_1', 'Address is required');
      isValid = false;
    }

    if (!city) {
      showError('#city', 'City is required');
      isValid = false;
    }

    if (!state) {
      showError('#state', 'State is required');
      isValid = false;
    } else if (!isEligibleState(state)) {
      showError(
        '#state',
        'Sorry, donations are only available in states where Carbliss is sold. Please visit drinkcarbliss.com/pages/find-carbliss to see our distribution areas.',
      );
      isValid = false;
    }

    if (!zip) {
      showError('#zip', 'ZIP code is required');
      isValid = false;
    } else {
      const zipRegex = /^\d{5}(-\d{4})?$/;
      if (!zipRegex.test(zip)) {
        showError('#zip', 'Please enter a valid ZIP code');
        isValid = false;
      }
    }
  }

  // Validate donation preference if visible
  if (isDonationPreferenceVisible) {
    if (!donationPreference) {
      showError('input[name="donation_preference"]', 'Please select a donation preference', true);
      isValid = false;
    }
  }

  // Validate Carbliss Cares form upload if visible
  if (isMonetaryUploadVisible) {
    if (!carblissCaresForm) {
      showError('#carbliss_cares_form', 'Please upload the completed Carbliss Cares form');
      isValid = false;
    }
  }

  // Validate shipping address fields if visible
  if (isShippingAddressVisible) {
    if (!shippingAddressLine1) {
      showError('#shipping_address_line_1', 'Shipping address is required');
      isValid = false;
    }

    if (!shippingCity) {
      showError('#shipping_city', 'Shipping city is required');
      isValid = false;
    }

    if (!shippingState) {
      showError('#shipping_state', 'Shipping state is required');
      isValid = false;
    } else if (!isEligibleState(shippingState)) {
      showError('#shipping_state', 'Sorry, donations can only be shipped to states where Carbliss is sold.');
      isValid = false;
    }

    if (!shippingZip) {
      showError('#shipping_zip', 'Shipping ZIP code is required');
      isValid = false;
    } else {
      const zipRegex = /^\d{5}(-\d{4})?$/;
      if (!zipRegex.test(shippingZip)) {
        showError('#shipping_zip', 'Please enter a valid ZIP code');
        isValid = false;
      }
    }
  }

  // Event flyer is always required
  if (!eventFlyer) {
    showError('#event_flyer', 'Event flyer is required');
    isValid = false;
  }

  return isValid;
}

// Helper function to show error messages
function showError(fieldSelector, message, isRadio = false) {
  const $field = $(fieldSelector);
  const $fieldGroup = $field.closest('.fcsi-field-group');

  $fieldGroup.addClass('has-error');

  if (isRadio) {
    $fieldGroup.append(`<span class="field-error">${message}</span>`);
  } else {
    $field.after(`<span class="field-error">${message}</span>`);
  }
}

// Helper function to validate email
function isValidEmail(email) {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
}

// Next button click
$('.fc-btn-next').on('click', function () {
  if (currentPage === 1 && validatePage1()) {
    goToPage(2);
  } else if (currentPage === 2 && validatePage2()) {
    goToPage(3);
  }
});

// Back button click
$('.fc-btn-back').on('click', function () {
  if (currentPage > 1) {
    goToPage(currentPage - 1);
  }
});

// Tax certification radio change
$('input[name="tax_cert"]').on('change', function () {
  userHasTaxCert = $(this).val() === 'yes';

  if (userHasTaxCert) {
    $('.fc-tax-cert-upload').show();
    $('#tax_cert_file').attr('required', true);
  } else {
    $('.fc-tax-cert-upload').hide();
    $('#tax_cert_file').attr('required', false).val('');
  }
});

// Donation preference radio change
$('input[name="donation_preference"]').on('change', function () {
  const isMonetary = $(this).val() === 'monetary';

  if (isMonetary) {
    $('.fc-monetary-donation-section').show();
    $('.fc-monetary-upload-field').show();
    $('#carbliss_cares_form').attr('required', true);
  } else {
    $('.fc-monetary-donation-section').hide();
    $('.fc-monetary-upload-field').hide();
    $('#carbliss_cares_form').attr('required', false).val('');
  }
});

// Shipping address checkbox change
$('#same_shipping_address').on('change', function () {
  toggleShippingAddress();
});

// Zip code validation and API call
$('#zip_code').on('input blur', function () {
  const zipCode = $(this).val().trim();
  const zipRegex = /^\d{5}(-\d{4})?$/;

  $('.zip-error').remove();
  $('.no-stores-message').remove();
  $(this).removeClass('error');

  // Reset store name field when zip changes
  $('#store_name').val('').attr('data-valid-store', 'false');
  $('.store-autocomplete').remove();

  if (zipCode && !zipRegex.test(zipCode)) {
    $(this).addClass('error');
    $(this).after(
      '<span class="zip-error field-error">Please enter the valid zip code of the location that currently sells Carbliss</span>',
    );
    $('.fcsi-autocomplete-group').hide();
    storeData = [];
  } else if (zipCode && zipRegex.test(zipCode)) {
    $('.fcsi-autocomplete-group').show();

    // Only make API call if zip code has changed
    if (zipCode !== lastFetchedZip) {
      lastFetchedZip = zipCode;

      $.ajax({
        url: 'https://api.drinkcarbliss.com/product-finder.php',
        method: 'POST',
        data: { zip: zipCode, miles: 100 },
        dataType: 'json',
        success: function (response) {
          storeData = response.location || [];
          console.log('Store data:', response);

          // Show message if no stores found
          if (storeData.length === 0) {
            $('.fcsi-autocomplete-group').after(
              '<p class="no-stores-message field-error">No stores found in this zip code. Please try a different zip code.</p>',
            );
          } else {
            $('.no-stores-message').remove();
          }
        },
        error: function (error) {
          console.error('Error fetching store data:', error);
          storeData = [];
          $('.fcsi-autocomplete-group').after(
            '<p class="no-stores-message field-error">Error loading stores. Please try again.</p>',
          );
        },
      });
    }
  } else {
    $('.fcsi-autocomplete-group').hide();
  }
});

// Find a store in the VIP results by exact (case-insensitive) name match
function findStoreByName(name) {
  const target = (name || '').trim().toLowerCase();
  if (!target || !Array.isArray(storeData) || storeData.length === 0) {
    return null;
  }
  return (
    storeData.find((store) => {
      const decodedName = $('<textarea/>').html(store.dba).text();
      return decodedName.trim().toLowerCase() === target;
    }) || null
  );
}

// Apply a VIP store selection: capture its SKU count and mark the field valid
function applyStoreSelection(store) {
  const decodedName = $('<textarea/>').html(store.dba).text();
  storeSkuCount = store.otherBrand ? store.otherBrand.length : 0;
  $('#store_name').val(decodedName).attr('data-sku-count', storeSkuCount).attr('data-valid-store', 'true');
  $('#sku_count').val(storeSkuCount);
  checkAddressVisibility();
}

// Store name autocomplete
$('#store_name').on('input', function () {
  const searchTerm = $(this).val().toLowerCase();

  // Mark as invalid whenever user types
  $(this).attr('data-valid-store', 'false');

  // Remove existing dropdown
  $('.store-autocomplete').remove();

  if (searchTerm.length === 0) {
    return;
  }

  if (storeData.length === 0) {
    return;
  }

  // Filter stores based on search term
  const filteredStores = storeData.filter((store) => store.dba.toLowerCase().includes(searchTerm));

  if (filteredStores.length === 0) {
    // Show "no results" message in dropdown
    const $dropdown = $('<ul class="store-autocomplete"></ul>');
    const $noResults = $('<li class="no-results"></li>').text('No matching stores found');
    $dropdown.append($noResults);
    $(this).after($dropdown);
    return;
  }

  // Create dropdown
  const $dropdown = $('<ul class="store-autocomplete"></ul>');

  filteredStores.forEach((store) => {
    const decodedName = $('<textarea/>').html(store.dba).text();
    const $item = $('<li></li>').text(decodedName);

    $item.on('click', function () {
      applyStoreSelection(store);
      $('.store-autocomplete').remove();
    });

    $dropdown.append($item);
  });

  $(this).after($dropdown);
});

// On blur, accept the typed location only if it exactly matches a VIP result
$('#store_name').on('blur', function () {
  // Delay so a dropdown item click is processed first
  setTimeout(function () {
    if ($('#store_name').attr('data-valid-store') === 'true') {
      return;
    }
    const matchedStore = findStoreByName($('#store_name').val());
    if (matchedStore) {
      applyStoreSelection(matchedStore);
    }
  }, 200);
});

// Close dropdown when clicking outside
$(document).on('click', function (e) {
  if (!$(e.target).closest('#store_name').length) {
    $('.store-autocomplete').remove();
  }
});

// Determine donation type based on form inputs
function determineDonationType() {
  const hasTaxCert = userHasTaxCert;
  const sellsCarbliss = carblissSoldAtLocation === true;
  const skuCount = storeSkuCount;

  console.log('Donation determination:', { hasTaxCert, sellsCarbliss, skuCount });

  // Eligibility: a donation requires the venue to be tax exempt AND to sell
  // Carbliss. Anything else is not eligible and receives the denial message.
  if (!hasTaxCert || !sellsCarbliss) {
    return 'Not Eligible';
  }

  // Tier is based purely on how many SKUs the Carbliss location carries. A
  // location that doesn't meet a tier's minimum drops to the next tier down.
  if (skuCount >= 8) return 'Large Donation';
  if (skuCount >= 5) return 'Semi-Large Donation';
  if (skuCount >= 3) return 'Bucket Donation';
  if (skuCount >= 1) return 'Small Donation';

  // Eligible but the location carries no SKUs on record, so it can't meet even
  // the Small Donation minimum of 1 SKU.
  return 'Not Eligible';
}

// Get donation items message based on type
function getDonationItems(donationType) {
  // Check if user selected monetary donation for Large Donation
  if (donationType === 'Large Donation') {
    const donationPreference = $('input[name="donation_preference"]:checked').val();
    if (donationPreference === 'monetary') {
      return 'Monetary Donation';
    } else {
      return 'LED - 18" Circle LED';
    }
  }

  const messages = {
    'Semi-Large Donation': 'Backpack Cooler, Crewneck, Baseball Hat, Tumbler',
    'Bucket Donation': 'Bucket, T-Shirt, Tumbler, Koozies (2), Can Opener, Can Toppers (2), Trucker Hat',
    'Small Donation': 'T-Shirt, Pint Glass, Can Opener, Can Topper (2), Koozies (2)',
  };

  return messages[donationType] || messages['Small Donation'];
}

// Show success modal
function showSuccessModal(donationItems, donationType) {
  $('#donation-items').text(donationItems);

  // Check if user selected monetary donation for Large Donation
  const donationPreference = $('input[name="donation_preference"]:checked').val();
  const isMonetaryDonation = donationType === 'Large Donation' && donationPreference === 'monetary';

  // Get the appropriate image URL based on donation type
  const $modal = $('#fc-success-modal');
  let imageUrl = '';

  // Don't show image for monetary donations
  if (!isMonetaryDonation) {
    switch (donationType) {
      case 'Large Donation':
        imageUrl = $modal.attr('data-large-donation-image');
        break;
      case 'Semi-Large Donation':
        imageUrl = $modal.attr('data-semi-large-donation-image');
        break;
      case 'Bucket Donation':
        imageUrl = $modal.attr('data-bucket-donation-image');
        break;
      case 'Small Donation':
        imageUrl = $modal.attr('data-small-donation-image');
        break;
    }
  }

  // Show image if URL exists and not monetary donation
  if (imageUrl && imageUrl.trim() !== '' && !isMonetaryDonation) {
    $('#donation-image').attr('src', imageUrl);
    $('#donation-image-container').show();
  } else {
    $('#donation-image-container').hide();
  }

  // Show/hide content based on donation type
  if (isMonetaryDonation) {
    // For monetary donations: show monetary-specific message, hide donation package details
    $('.success-intro').hide();
    $('.success-intro-monetary').show();
    $('.donation-package-label').hide();
    $('#donation-items').hide();
  } else {
    // For all other donations: show standard success intro and donation items
    $('.success-intro').show();
    $('.success-intro-monetary').hide();
    $('.donation-package-label').show();
    $('#donation-items').show();
  }

  $modal.addClass('show');
  $('body').css('overflow', 'hidden'); // Prevent scrolling
}

// Show error modal
function showErrorModal(errorMessage) {
  $('#error-message').text(errorMessage || 'Please try again or contact support if the problem persists.');
  $('#fc-error-modal').addClass('show');
  $('body').css('overflow', 'hidden'); // Prevent scrolling
}

// Show denial / not-eligible modal
function showDenialModal() {
  $('#fc-denial-modal').addClass('show');
  $('body').css('overflow', 'hidden'); // Prevent scrolling
}

// Set loading state on submit button
function setLoadingState(isLoading) {
  const $submitBtn = $('.fc-btn-submit');

  if (isLoading) {
    $submitBtn.prop('disabled', true).html('<span class="spinner"></span> Submitting...');
  } else {
    $submitBtn.prop('disabled', false).html('Submit');
  }
}

// Form submission
$('#fc-donation-form').on('submit', function (e) {
  e.preventDefault();

  if (!validatePage3()) {
    return;
  }

  // Determine donation type
  const donationType = determineDonationType();

  // Not eligible: show the denial message and stop (nothing is submitted).
  if (donationType === 'Not Eligible') {
    showDenialModal();
    return;
  }

  const donationItems = getDonationItems(donationType);

  // Set hidden field value
  $('#donation_type').val(donationType);

  // Collect form data
  const formData = new FormData(this);

  console.log('Form submitted with data:');
  for (let [key, value] of formData.entries()) {
    console.log(`${key}: ${value}`);
  }
  console.log('Donation Type:', donationType);
  console.log('Donation Items:', donationItems);

  // Set loading state
  setLoadingState(true);

  // Submit to API
  $.ajax({
    url: 'https://api.drinkcarbliss.com/dono-form.php',
    method: 'POST',
    data: formData,
    processData: false, // Important for file uploads
    contentType: false, // Important for file uploads
    timeout: 30000, // 30 second timeout
    success: function (response) {
      console.log('API Response:', response);
      setLoadingState(false);

      // Check if response indicates success
      if (response.success || response.status === 'success') {
        showSuccessModal(donationItems, donationType);
      } else {
        const errorMsg = response.message || response.error || 'Submission failed. Please try again.';
        showErrorModal(errorMsg);
      }
    },
    error: function (xhr, status, error) {
      console.error('API Error:', { xhr, status, error });
      setLoadingState(false);

      let errorMessage = 'An error occurred while submitting your request.';

      if (status === 'timeout') {
        errorMessage = 'The request timed out. Please check your connection and try again.';
      } else if (status === 'error') {
        if (xhr.status === 0) {
          errorMessage = 'Unable to connect to the server. Please check your internet connection.';
        } else if (xhr.status === 404) {
          errorMessage = 'The submission endpoint could not be found. Please contact support.';
        } else if (xhr.status === 500) {
          errorMessage = 'A server error occurred. Please try again later.';
        } else {
          errorMessage = `Error ${xhr.status}: ${error}`;
        }
      }

      showErrorModal(errorMessage);
    },
  });
});

// File upload validation
function validateFileInput(input) {
  const file = input.files[0];
  const $input = $(input);
  const $fieldGroup = $input.closest('.fcsi-field-group');

  // Remove previous error messages
  $fieldGroup.find('.file-error').remove();
  $input.removeClass('error');

  if (!file) {
    return true; // No file selected is okay if not required at this point
  }

  // Check file count
  if (input.files.length > 1) {
    $input.addClass('error');
    $input.after('<span class="file-error field-error">Please select only one file.</span>');
    input.value = ''; // Clear the input
    return false;
  }

  // Check file type
  const allowedTypes = [
    'image/jpeg',
    'image/jpg',
    'image/png',
    'image/gif',
    'image/webp',
    'application/pdf',
    'application/msword',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  ];
  const allowedExtensions = ['.jpg', '.jpeg', '.png', '.gif', '.webp', '.pdf', '.doc', '.docx'];
  const fileName = file.name.toLowerCase();
  const fileExtension = '.' + fileName.split('.').pop();

  if (!allowedTypes.includes(file.type) && !allowedExtensions.includes(fileExtension)) {
    $input.addClass('error');
    $input.after(
      '<span class="file-error field-error">Invalid file type. Please upload a PDF, DOC, DOCX, or image file (JPG, JPEG, PNG).</span>',
    );
    input.value = ''; // Clear the input
    return false;
  }

  // Check file size (5MB max)
  const maxSize = 5 * 1024 * 1024; // 5MB in bytes
  if (file.size > maxSize) {
    $input.addClass('error');
    $input.after('<span class="file-error field-error">File size must be less than 5MB.</span>');
    input.value = ''; // Clear the input
    return false;
  }

  return true;
}

// Attach file validation to file inputs
$('input[type="file"]').on('change', function () {
  validateFileInput(this);
});

// Initialize
$(document).ready(function () {
  // Hide conditional fields on load
  $('.fc-tax-cert-upload').hide();
  $('.fcsi-autocomplete-group').hide();
  $('.fc-donation-preference-field').hide();
  $('.fc-monetary-donation-section').hide();
  $('.fc-monetary-upload-field').hide();
  $('.fc-shipping-address-fields').hide();

  // Initialize store name as invalid
  $('#store_name').attr('data-valid-store', 'false');

  // Initialize shipping address checkbox (checked by default, fields hidden)
  $('#same_shipping_address').prop('checked', true);
  toggleShippingAddress();

  // Start on page 1
  goToPage(1);
});
